/**
 * #1011 — Field lists for subsection header fill counts (Request Field Registry projections).
 */
export {
  OPPORTUNITY_REQUESTOR_SUBSECTION_FIELDS,
  OPPORTUNITY_PROJECT_SUMMARY_SUBSECTION_FIELDS,
  OPPORTUNITY_DEAL_REGISTRATION_SUBSECTION_FIELDS,
  OPPORTUNITY_SCALE_TIMELINE_SUBSECTION_FIELDS,
  OPPORTUNITY_NOTES_SUBSECTION_FIELDS,
  SITE_DIMENSIONS_SUBSECTION_FIELDS,
  SITE_INFORMATION_NOTES_SUBSECTION_FIELDS,
  FACILITY_POWER_SUBSECTION_FIELDS,
  FACILITY_POWER_LARGE_UPS_SUBSECTION_FIELDS,
  LARGE_UPS_EDITOR_SUBSECTION_FIELDS,
  FACILITY_POWER_DISTRIBUTION_SUBSECTION_FIELDS,
  POWER_DISTRIBUTION_EDITOR_SUBSECTION_FIELDS,
  FACILITY_POWER_NOTES_SUBSECTION_FIELDS,
  LARGE_UPS_NOTES_SUBSECTION_FIELDS,
  COOLING_MAIN_SUBSECTION_FIELDS,
  COOLING_SYSTEM_EDITOR_SUBSECTION_FIELDS,
  COOLING_NOTES_SUBSECTION_FIELDS,
  SMALL_UPS_MAIN_SUBSECTION_FIELDS,
  SMALL_UPS_EDITOR_SUBSECTION_FIELDS,
  SMALL_UPS_NOTES_SUBSECTION_FIELDS,
  RACK_INFORMATION_SUBSECTION_FIELDS,
  RACK_SPECS_SUBSECTION_FIELDS,
  RACK_POWER_INFO_SUBSECTION_FIELDS,
  RACK_POWER_NOTES_SUBSECTION_FIELDS,
  RACK_MODAL_FACILITY_POWER_FIELDS_EXCLUDED,
  RACK_MODAL_RACKS_FIELDS,
  RACK_MODAL_POWER_FIELDS,
  RACK_MODAL_ADDITIONAL_FIELDS,
  LIQUID_COOLING_PROJECT_SUBSECTION_FIELDS,
  LIQUID_COOLING_CDU_EDITOR_SUBSECTION_FIELDS,
  LIQUID_COOLING_NOTES_SUBSECTION_FIELDS,
  LIQUID_COOLING_SYSTEM_SUBSECTION_FIELDS,
  LIQUID_COOLING_PRIMARY_SUBSECTION_FIELDS,
  LIQUID_COOLING_SECONDARY_SUBSECTION_FIELDS,
  MONITORING_MAIN_SUBSECTION_FIELDS,
  MONITORING_NOTES_SUBSECTION_FIELDS,
} from '../request/fields/requestFieldRegistry';
